module.exports = __webpack_public_path__ + "static/img/3.0b36df0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/包包/3.png
// module id = lfV5
// module chunks = 0